module.exports = __webpack_public_path__ + "img/Amazon.f95a576d.png";